import { render, staticRenderFns } from "./lot-units.html?vue&type=template&id=f96dc638&scoped=true&"
import script from "./lot-units.ts?vue&type=script&lang=js&"
export * from "./lot-units.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96dc638",
  null
  
)

export default component.exports